import { gql } from "@apollo/client";

export const GET_MASTER_DATA_PRODUCTS = gql`
  query MasterDataProducts($params: MasterDataProductsParamsInput!) {
    masterDataProducts(params: $params) {
      total
      page
      limit
      items {
        productId
        productKey
        itemName
        itemDescription
        upcItemNumber
        glItemNumber
        glItemDescription
        isActive
        categoryId
        categoryName
        categoryKey
        uomId
        uomCode
        uomName
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
